<template>
  <div>
    <center>
      <video @click="pause_play" id="video" :key="src">
        <source type="video/mp4" :src="src" />
      </video>
      <div v-if="displayChoices">
        <div class="choices">
          <div
            v-for="(choice, index) in clip.choices"
            :key="index"
            @click="$emit('to', choice.to, choice.score)"
            class="choice"
          >
            <div class="choice-text">
              {{ choice.text }}
            </div>
          </div>
        </div>
      </div>
    </center>
  </div>
</template>

<script>
export default {
  name: "Video",
  props: {
    filename: {
      required: true
    },
    clip: {
      required: true
    }
  },
  data() {
    return {
      start: 0,
      duration: 0,
      displayChoices: false,
      tries: 0
    };
  },
  methods: {
    pause_play() {
      if (!document.getElementById("video").paused) {
        document.getElementById("video").pause();
        this.duration = this.duration - Date.now() + this.start
      } else {
        document.getElementById("video").play();
        this.start = Date.now()
      }
    },
    play() {
      if (document.getElementById("video").paused) {
        document.getElementById("video").play();
        this.start = Date.now()
      }
    },
    loadData() {
      if (document.getElementById("video")) {
        if (!this.duration) {
          this.duration = document.getElementById("video").duration * 1000;
        }
        if (this.tries < 2) {
          this.tries += 1
          this.play()
        }
        if (!document.getElementById("video").paused) {
          this.displayChoices = Date.now() - this.start > this.duration - (this.clip.time || 8000);
        }
        if (document.getElementById("video").ended) {
          if (this.clip.default) {
            this.$emit('to', this.clip.default.to, this.clip.default.score)
          }
        }
      }
    }
  },
  computed: {
    src() {
      return require(`./../assets/${this.filename}`);
    }
  },
  watch: {
    src: function() {
      this.displayChoices = false;
      this.duration = 0;
      //this.start = Date.now();
      this.tries = 0;
    }
  },
  mounted: function() {
    window.setInterval(() => {
      this.loadData();
    }, 500)
  }
}
</script>

<style scoped lang="scss">  
  #video {
    max-height: 80vh;
    max-width: 100%;
  }

  .choices {
    height: 18vh;
    display: flex;
    flex-direction: row;
  }

  .choice {
    position: relative;
    flex-grow: 1;
    cursor: pointer;
  }

  .choice:hover {
    background-color: #353535;
  }

  .choice-text {
    font-size: 0.5em;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    text-align: center;
    width: 100%;
  }
</style>
